import { useMutation } from '@tanstack/react-query';

import { fetchWithCsrfToken } from 'utils/fetchWrapper';

export interface DeleteDocumentRequirementsVariables {
  interviewUid: string;
  documentId: string;
}

interface DeleteDocumentRequirementsResponse {
  message: string;
}

const useDeleteDocumentRequirement = () => {
  const {
    mutateAsync: deleteDocumentRequirement,
    data,
    isLoading,
    error,
  } = useMutation<
    DeleteDocumentRequirementsResponse,
    Error,
    DeleteDocumentRequirementsVariables
  >(['deleteDocumentRequirement'], async ({ interviewUid, documentId }) => {
    const body = {
      interview: interviewUid,
      document_id: documentId,
    };

    const response =
      await fetchWithCsrfToken<DeleteDocumentRequirementsResponse>(
        'builder/async/document_requirement/delete',
        'POST',
        body
      );

    return response;
  });

  return {
    deleteDocumentRequirement,
    data,
    isLoading,
    error,
  };
};

export default useDeleteDocumentRequirement;
